export const TIME_FORMAT_PREFERENCE_KEY = "timeFormat";

export const TIME_FORMATS = Object.freeze({
  SYSTEM: "system",
  TWELVE_HOUR: "12h",
  TWENTY_FOUR_HOUR: "24h",
});

export const normalizeTimeFormat = (value) =>
  Object.values(TIME_FORMATS).includes(value) ? value : TIME_FORMATS.SYSTEM;

export const getTimeFormatPreference = () =>
  normalizeTimeFormat(localStorage.getItem(TIME_FORMAT_PREFERENCE_KEY));

export const setTimeFormatPreference = (value) => {
  const preference = normalizeTimeFormat(value);
  localStorage.setItem(TIME_FORMAT_PREFERENCE_KEY, preference);
  return preference;
};

export const formatTime = (value, options = {}) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  const preference = getTimeFormatPreference();
  const hour12 = preference === TIME_FORMATS.SYSTEM
    ? undefined
    : preference === TIME_FORMATS.TWELVE_HOUR;

  return new Intl.DateTimeFormat(options.locale, {
    hour: "2-digit",
    minute: "2-digit",
    ...options,
    hour12,
  }).format(date);
};

export const formatTimeRange = (start, end, options = {}) =>
  `${formatTime(start, options)} - ${formatTime(end, options)}`;

export const formatDateTime = (value, locale) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return `${new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(date)} ${formatTime(date, { locale })}`;
};
